<mat-card class="b-1 shadow-none">
  <mat-card-title class="p-16">
    <div class="row">
      <div
        class="col-12 col-md-6 d-flex justify-content-start align-items-center mb-2 mb-md-0">
        <h4 Ctitle>Account Setting</h4>
      </div>
      <div
        class="col-12 col-md-6 d-flex justify-content-start justify-content-md-end align-items-center">
        <div
          class="w-100 w-md-auto d-flex justify-content-start justify-content-md-end">
          <ul class="breadcrumb mb-0">
            <li class="breadcrumb-item">
              <a routerLink="/crm/crm-dashboard" class="text-body-color"
                >Dashboard</a
              >
            </li>

            <li class="breadcrumb-item active text-nowrap">
              <span class="rounded p-x-8 p-y-2 text-primary bg-light-primary">
                Account Setting
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </mat-card-title>
</mat-card>

<div class="account-setting-container">
  <!-- Tabs Navigation -->
  <mat-tab-group
    [(selectedIndex)]="selectedTabIndex"
    (selectedIndexChange)="onTabChange($event)"
    class="account-tabs">
    <!-- Account Tab -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon>person</mat-icon>
        <span>Account</span>
      </ng-template>

      <div class="tab-content">
        <div class="row">
          <!-- Change Profile Section -->
          <div class="col-md-12 mb-4">
            <mat-card class="profile-card">
              <mat-card-header>
                <mat-card-title>Change Profile</mat-card-title>
                <mat-card-subtitle
                  >Change your profile picture from here</mat-card-subtitle
                >
              </mat-card-header>
              <mat-card-content>
                <div class="profile-picture-section">
                  <app-file-dropzone
                    class="d-block"
                    ariaLabel="Profile picture"
                    accept="image/jpeg,image/jpg,image/png,image/gif"
                    hint="Allowed JPG, GIF or PNG. Max size of 800K"
                    (filesSelected)="uploadProfileImage($event)">
                    <img
                      appFileDropzonePreview
                      [src]="profileImage"
                      alt="Profile"
                      class="profile-image"
                      *ngIf="profileImage"
                      (error)="onImageError($event)"
                      (load)="onImageLoad($event)"
                      loading="eager" />
                  </app-file-dropzone>
                  <div class="profile-actions m-t-10">
                    <button mat-stroked-button (click)="resetProfileImage()">
                      Reset
                    </button>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </div>

        <!-- Personal Details Section -->
        <div class="row">
          <div class="col-12">
            <mat-card class="personal-details-card">
              <mat-card-header>
                <mat-card-title>Personal Details</mat-card-title>
                <mat-card-subtitle
                  >To change your personal detail, edit and save from
                  here</mat-card-subtitle
                >
              </mat-card-header>
              <mat-card-content>
                <form [formGroup]="personalDetailsForm">
                  <div class="row">
                    <div class="col-md-6">
                      <!-- First Name (superadmin only) -->
                      <mat-form-field
                        *ngIf="isSuperAdmin"
                        appearance="outline"
                        class="w-100">
                        <mat-label>First Name**</mat-label>
                        <input matInput formControlName="firstName" />
                      </mat-form-field>

                      <!-- Last Name (superadmin only) -->
                      <mat-form-field
                        *ngIf="isSuperAdmin"
                        appearance="outline"
                        class="w-100">
                        <mat-label>Last Name**</mat-label>
                        <input matInput formControlName="lastName" />
                      </mat-form-field>

                      <!-- Title (superadmin only) -->
                      <mat-form-field
                        *ngIf="isSuperAdmin"
                        appearance="outline"
                        class="w-100">
                        <mat-label>Title**</mat-label>
                        <input matInput formControlName="title" />
                      </mat-form-field>

                      <!-- Email (superadmin only) -->
                      <mat-form-field
                        *ngIf="isSuperAdmin"
                        appearance="outline"
                        class="w-100">
                        <mat-label>Email**</mat-label>
                        <input matInput type="email" formControlName="email" />
                      </mat-form-field>

                      <!-- Phone (all users) -->
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Phone*</mat-label>
                        <input matInput formControlName="phone" />
                      </mat-form-field>

                      <!-- Adresse (all users) -->
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Adresse</mat-label>
                        <input
                          matInput
                          formControlName="adresse"
                          placeholder="Entrez votre adresse" />
                      </mat-form-field>
                    </div>
                    <div class="col-md-6">
                      <!-- Business Unit (superadmin only) -->
                      <mat-form-field
                        *ngIf="isSuperAdmin"
                        appearance="outline"
                        class="w-100">
                        <mat-label>Business Unit**</mat-label>
                        <mat-select formControlName="userBu">
                          <mat-option
                            *ngFor="let bu of listeBu"
                            [value]="bu.slug">
                            {{ bu.name }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>

                      <!-- Location (superadmin only) - Buttons -->
                      <div
                        *ngIf="isSuperAdmin"
                        class="location-buttons-section">
                        <label class="location-label">Location*</label>
                        <div class="location-buttons">
                          <button
                            *ngFor="let loc of locations"
                            type="button"
                            mat-stroked-button
                            [class.selected]="
                              personalDetailsForm.get('location')?.value ===
                              loc.value
                            "
                            (click)="selectLocation(loc.value)"
                            class="location-button">
                            {{ loc.label }}
                          </button>
                        </div>
                        <input type="hidden" formControlName="location" />
                      </div>
                    </div>
                  </div>
                </form>
              </mat-card-content>
            </mat-card>
          </div>
        </div>
      </div>
    </mat-tab>

    <!-- Notifications Tab -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon>notifications</mat-icon>
        <span>Notifications</span>
      </ng-template>

      <div class="tab-content">
        <!-- Notification Preferences -->
        <mat-card class="mb-4">
          <mat-card-header>
            <div
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 100%;
              ">
              <div>
                <mat-card-title>Notification Preferences</mat-card-title>
                <mat-card-subtitle>
                  Select the notifications you would like to receive via email.
                  Your preferences are saved automatically when you toggle a
                  notification. Please note that you cannot opt out of receiving
                  service messages, such as payment, security or legal
                  notifications.
                </mat-card-subtitle>
              </div>
              <div style="display: flex; gap: 8px">
                <!-- Bouton avec menu déroulant pour les rôles -->
               <!-- <button
                  mat-raised-button
                  [matMenuTriggerFor]="rolesMenu"
                  color="primary">
                  <mat-icon style="margin-right: 8px">badge</mat-icon>
                  Filtrer par Rôles
                  <span
                    *ngIf="selectedFilterRoles.length > 0"
                    style="
                      margin-left: 8px;
                      background-color: rgba(255, 255, 255, 0.3);
                      padding: 2px 8px;
                      border-radius: 12px;
                      font-size: 12px;
                    ">
                    {{ selectedFilterRoles.length }}
                  </span>
                </button>-->
                <mat-menu
                  #rolesMenu="matMenu"
                  style="max-height: 400px; overflow-y: auto">
                  <div style="padding: 8px">
                    <div
                      style="
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        margin-bottom: 8px;
                        padding-bottom: 8px;
                        border-bottom: 1px solid #e0e0e0;
                      ">
                      <strong>Rôles</strong>
                      <button
                        mat-button
                        (click)="
                          allRolesSelected
                            ? deselectAllRoles()
                            : selectAllRoles()
                        "
                        style="
                          font-size: 12px;
                          min-width: auto;
                          padding: 0 8px;
                        ">
                        {{ allRolesSelected ? 'Tout décocher' : 'Tout cocher' }}
                      </button>
                    </div>
                    <div
                      *ngFor="let role of allAvailableRoles"
                      style="padding: 4px 0">
                      <mat-checkbox
                        [(ngModel)]="role.selected"
                        (change)="updateSelectedFilterRoles()"
                        style="width: 100%">
                        <strong>{{ role.name }}</strong>
                        <span
                          *ngIf="role.description"
                          style="
                            color: #666;
                            font-size: 12px;
                            display: block;
                            margin-left: 24px;
                          ">
                          {{ role.description }}
                        </span>
                      </mat-checkbox>
                    </div>
                    <div
                      *ngIf="allAvailableRoles.length === 0"
                      style="padding: 16px; text-align: center; color: #666">
                      <p style="margin: 0; font-size: 12px">
                        Aucun rôle disponible
                      </p>
                    </div>
                  </div>
                </mat-menu>

                <!-- Bouton pour tester les notifications -->
                <!--<button
                  mat-raised-button
                  color="accent"
                  (click)="goToNotificationTest()">
                  <mat-icon style="margin-right: 8px">science</mat-icon>
                  Tester les Notifications
                </button>-->
              </div>
            </div>
          </mat-card-header>
          <mat-card-content>
            <form [formGroup]="notificationsForm">
              <mat-form-field appearance="outline" class="w-100 mb-4">
                <mat-label>Email Address*</mat-label>
                <input matInput type="email" formControlName="email" />
                <mat-hint>Required for notifications.</mat-hint>
              </mat-form-field>

              <div class="notification-options">
                <!-- Message si aucune notification disponible -->
                <div
                  *ngIf="getAllNotifications().length === 0"
                  class="no-notifications-message"
                  style="padding: 20px; text-align: center; color: #666">
                  <mat-icon
                    style="
                      font-size: 48px;
                      width: 48px;
                      height: 48px;
                      margin-bottom: 10px;
                    "
                    >notifications_off</mat-icon
                  >
                  <p style="font-size: 16px; margin: 0">
                    Aucune notification disponible pour vos rôles actuels.
                  </p>
                </div>

                <!-- Section: Notifications "Affiché pour Tous" -->
                <div
                  *ngIf="getNotificationsForAll().length > 0"
                  style="margin-bottom: 32px">
                  <!-- En-tête de section -->
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      margin-bottom: 16px;
                      padding-bottom: 12px;
                      border-bottom: 2px solid #4caf50;
                    ">
                    <mat-icon style="margin-right: 8px; color: #4caf50"
                      >public</mat-icon
                    >
                    <h3
                      style="
                        margin: 0;
                        font-size: 18px;
                        font-weight: 600;
                        color: #4caf50;
                      ">
                      Affiché pour Tous
                    </h3>
                    <span
                      style="margin-left: auto; color: #666; font-size: 14px"
                      >{{
                        getNotificationsForAll().length
                      }}
                      notification(s)</span
                    >
                  </div>

                  <!-- Liste des notifications "Affiché pour Tous" -->
                  <div
                    *ngFor="let pref of getNotificationsForAll()"
                    style="margin-bottom: 16px">
                    <!-- Rectangle de notification -->
                    <div
                      class="notification-item"
                      [class.notification-enabled]="
                        getNotificationPreference(pref.key)
                      "
                      [class.notification-disabled]="
                        !getNotificationPreference(pref.key)
                      ">
                      <div class="notification-info">
                        <mat-icon>{{ pref.icon }}</mat-icon>
                        <div class="notification-text">
                          <h4>{{ pref.title }}</h4>
                          <p>{{ pref.desc }}</p>
                        </div>
                      </div>
                      <mat-slide-toggle
                        [checked]="getNotificationPreference(pref.key)"
                        (toggleChange)="toggleNotification(pref.key)">
                      </mat-slide-toggle>
                    </div>
                  </div>
                </div>

                <!-- Section: Notifications avec rôles requis -->
                <div *ngIf="getNotificationsWithRoles().length > 0">
                  <!-- Liste des notifications avec rôles -->
                  <div
                    *ngFor="let pref of getNotificationsWithRoles()"
                    style="margin-bottom: 16px">
                    <!-- Affichage des rôles associés au-dessus du rectangle -->
                    <div
                      class="notification-roles"
                      style="
                        margin-bottom: 8px;
                        display: flex;
                        align-items: center;
                        flex-wrap: wrap;
                        gap: 6px;
                      ">
                      <mat-icon
                        style="
                          font-size: 16px;
                          width: 16px;
                          height: 16px;
                          color: #666;
                          margin-right: 4px;
                        "
                        >badge</mat-icon
                      >
                      <span style="font-size: 12px; color: #666">
                        <span style="font-weight: 500">Rôles requis:</span>
                        <span
                          *ngFor="
                            let role of pref.requiredRoles;
                            let last = last
                          "
                          style="margin-left: 4px">
                          <span
                            style="
                              background-color: #e3f2fd;
                              color: #1976d2;
                              padding: 2px 8px;
                              border-radius: 12px;
                              font-size: 11px;
                              font-weight: 500;
                            "
                            >{{ role }}</span
                          >
                          <span *ngIf="!last" style="margin: 0 4px; color: #999"
                            >•</span
                          >
                        </span>
                      </span>
                    </div>

                    <!-- Rectangle de notification -->
                    <div
                      class="notification-item"
                      [class.notification-enabled]="
                        getNotificationPreference(pref.key)
                      "
                      [class.notification-disabled]="
                        !getNotificationPreference(pref.key)
                      ">
                      <div class="notification-info">
                        <mat-icon>{{ pref.icon }}</mat-icon>
                        <div class="notification-text">
                          <h4>{{ pref.title }}</h4>
                          <p>{{ pref.desc }}</p>
                        </div>
                      </div>
                      <mat-slide-toggle
                        [checked]="getNotificationPreference(pref.key)"
                        (toggleChange)="toggleNotification(pref.key)">
                      </mat-slide-toggle>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </mat-card-content>
        </mat-card>

        <!-- Date & Time 
        <mat-card class="mb-4">
          <mat-card-header>
            <mat-card-title>Date & Time</mat-card-title>
            <mat-card-subtitle
              >Time zones and calendar display settings.</mat-card-subtitle
            >
          </mat-card-header>
          <mat-card-content>
            <div class="timezone-section">
              <mat-icon>schedule</mat-icon>
              <span>{{ timezone }}</span>
              <mat-icon class="dropdown-icon">keyboard_arrow_down</mat-icon>
            </div>
          </mat-card-content>
        </mat-card>

       Ignore Tracking 
        <mat-card>
          <mat-card-header>
            <mat-card-title>Ignore Tracking</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="tracking-section">
              <mat-icon>schedule</mat-icon>
              <span>Browser Cookie</span>
              <mat-slide-toggle
                [(ngModel)]="ignoreBrowserTracking"></mat-slide-toggle>
            </div>
          </mat-card-content>
        </mat-card>-->
      </div>
    </mat-tab>

    <!-- Configuration Tab -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon>settings</mat-icon>
        <span>Configuration</span>
      </ng-template>

      <div class="tab-content">
        <!-- Pagination Configuration -->
        <mat-card class="mb-4">
          <mat-card-header>
            <div
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 100%;
              ">
              <div>
                <mat-card-title>Pagination Configuration</mat-card-title>
                <mat-card-subtitle>
                  Set the number of items to display per page for each section
                  of the application. Each page can have its own pagination
                  configuration.
                </mat-card-subtitle>
              </div>
              <div style="display: flex; gap: 8px">
                <!-- Bouton avec menu déroulant pour les rôles -->
                <!--<button
                  mat-raised-button
                  [matMenuTriggerFor]="paginationRolesMenu"
                  color="primary">
                  <mat-icon style="margin-right: 8px">badge</mat-icon>
                  Filter by Roles
                  <span
                    *ngIf="selectedPaginationFilterRoles.length > 0"
                    style="
                      margin-left: 8px;
                      background-color: rgba(255, 255, 255, 0.3);
                      padding: 2px 8px;
                      border-radius: 12px;
                      font-size: 12px;
                    ">
                    {{ selectedPaginationFilterRoles.length }}
                  </span>
                </button>-->
                <mat-menu
                  #paginationRolesMenu="matMenu"
                  style="max-height: 400px; overflow-y: auto">
                  <div style="padding: 8px">
                    <div
                      style="
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        margin-bottom: 8px;
                        padding-bottom: 8px;
                        border-bottom: 1px solid #e0e0e0;
                      ">
                      <strong>Roles</strong>
                      <button
                        mat-button
                        (click)="
                          allPaginationRolesSelected
                            ? deselectAllPaginationRoles()
                            : selectAllPaginationRoles()
                        "
                        style="
                          font-size: 12px;
                          min-width: auto;
                          padding: 0 8px;
                        ">
                        {{
                          allPaginationRolesSelected
                            ? 'Deselect All'
                            : 'Select All'
                        }}
                      </button>
                    </div>
                    <div
                      *ngFor="let role of allAvailablePaginationRoles"
                      style="padding: 4px 0">
                      <mat-checkbox
                        [(ngModel)]="role.selected"
                        (change)="updateSelectedPaginationFilterRoles()"
                        style="width: 100%">
                        <strong>{{ role.name }}</strong>
                        <span
                          *ngIf="role.description"
                          style="
                            color: #666;
                            font-size: 12px;
                            display: block;
                            margin-left: 24px;
                          ">
                          {{ role.description }}
                        </span>
                      </mat-checkbox>
                    </div>
                    <div
                      *ngIf="allAvailablePaginationRoles.length === 0"
                      style="padding: 16px; text-align: center; color: #666">
                      <p style="margin: 0; font-size: 12px">
                        No roles available
                      </p>
                    </div>
                  </div>
                </mat-menu>
              </div>
            </div>
          </mat-card-header>
          <mat-card-content>
            <div class="pagination-config-list">
              <!-- Message si aucune page disponible -->
              <div
                *ngIf="getAllPaginationPages().length === 0"
                class="no-pages-message"
                style="padding: 20px; text-align: center; color: #666">
                <mat-icon
                  style="
                    font-size: 48px;
                    width: 48px;
                    height: 48px;
                    margin-bottom: 10px;
                  "
                  >settings</mat-icon
                >
                <p style="font-size: 16px; margin: 0">
                  No pages available for your current role filters.
                </p>
              </div>

              <!-- Section: Pages "Available to All" -->
              <div
                *ngIf="getPaginationPagesForAll().length > 0"
                style="margin-bottom: 32px">
                <!-- En-tête de section -->
                <div
                  style="
                    display: flex;
                    align-items: center;
                    margin-bottom: 16px;
                    padding-bottom: 12px;
                    border-bottom: 2px solid #4caf50;
                  ">
                  <mat-icon style="margin-right: 8px; color: #4caf50"
                    >public</mat-icon
                  >
                  <h3
                    style="
                      margin: 0;
                      font-size: 18px;
                      font-weight: 600;
                      color: #4caf50;
                    ">
                    Available to All
                  </h3>
                  <span style="margin-left: auto; color: #666; font-size: 14px"
                    >{{ getPaginationPagesForAll().length }} page(s)</span
                  >
                </div>

                <!-- Liste des pages "Available to All" -->
                <div
                  *ngFor="let page of getPaginationPagesForAll()"
                  class="pagination-page-item">
                  <div class="page-info">
                    <div class="page-header">
                      <mat-icon class="page-icon">{{ page.icon }}</mat-icon>
                      <div class="page-title-desc">
                        <h4 class="page-title">{{ page.title }}</h4>
                        <p class="page-description">{{ page.description }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="page-action">
                    <mat-form-field
                      appearance="outline"
                      class="pagination-select">
                      <mat-label>Items per page</mat-label>
                      <mat-select
                        [(ngModel)]="pagePaginationPreferences[page.pageId]"
                        (ngModelChange)="
                          updatePagePagination(page.pageId, $event)
                        "
                        [disabled]="!canConfigurePage(page.requiredRoles)">
                        <mat-option
                          *ngFor="let option of getPageSizeOptions(page)"
                          [value]="option">
                          {{ option }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              </div>

              <!-- Section: Pages avec rôles requis -->
              <div *ngIf="getPaginationPagesWithRoles().length > 0">
                <!-- Liste des pages avec rôles -->
                <div
                  *ngFor="let page of getPaginationPagesWithRoles()"
                  style="margin-bottom: 16px">
                  <!-- Affichage des rôles associés au-dessus du rectangle -->
                  <div
                    class="notification-roles"
                    style="
                      margin-bottom: 8px;
                      display: flex;
                      align-items: center;
                      flex-wrap: wrap;
                      gap: 6px;
                    ">
                    <mat-icon
                      style="
                        font-size: 16px;
                        width: 16px;
                        height: 16px;
                        color: #666;
                        margin-right: 4px;
                      "
                      >badge</mat-icon
                    >
                    <span style="font-size: 12px; color: #666">
                      <span style="font-weight: 500">Rôles requis:</span>
                      <span
                        *ngFor="let role of page.requiredRoles; let last = last"
                        style="margin-left: 4px">
                        <span
                          style="
                            background-color: #e3f2fd;
                            color: #1976d2;
                            padding: 2px 8px;
                            border-radius: 12px;
                            font-size: 11px;
                            font-weight: 500;
                          "
                          >{{ role }}</span
                        >
                        <span *ngIf="!last" style="margin: 0 4px; color: #999"
                          >•</span
                        >
                      </span>
                    </span>
                  </div>

                  <!-- Rectangle de page -->
                  <div
                    class="pagination-page-item"
                    style="
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                      padding: 16px;
                      border: 1px solid #e0e0e0;
                      border-radius: 4px;
                      background-color: #f5f5f5;
                    ">
                    <div
                      class="page-info"
                      style="display: flex; align-items: center; flex: 1">
                      <mat-icon style="margin-right: 12px; color: #666">{{
                        page.icon
                      }}</mat-icon>
                      <div class="page-title-desc">
                        <h4
                          style="
                            margin: 0;
                            font-size: 16px;
                            font-weight: 500;
                            color: #333;
                          ">
                          {{ page.title }}
                        </h4>
                        <p
                          style="
                            margin: 4px 0 0 0;
                            font-size: 13px;
                            color: #666;
                          ">
                          {{ page.description }}
                        </p>
                      </div>
                    </div>
                    <div class="page-action">
                      <mat-form-field
                        appearance="outline"
                        class="pagination-select"
                        style="min-width: 150px">
                        <mat-label>Items per page</mat-label>
                        <mat-select
                          [(ngModel)]="pagePaginationPreferences[page.pageId]"
                          (ngModelChange)="
                            updatePagePagination(page.pageId, $event)
                          "
                          [disabled]="!canConfigurePage(page.requiredRoles)">
                          <mat-option
                            *ngFor="let option of getPageSizeOptions(page)"
                            [value]="option">
                            {{ option }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              style="
                margin-top: 24px;
                padding: 16px;
                background-color: #e3f2fd;
                border-radius: 4px;
                border-left: 4px solid #1976d2;
              ">
              <div style="display: flex; align-items: start">
                <mat-icon
                  style="
                    vertical-align: middle;
                    margin-right: 12px;
                    color: #1976d2;
                    margin-top: 2px;
                  "
                  >info</mat-icon
                >
                <div>
                  <strong
                    style="
                      color: #1976d2;
                      font-size: 14px;
                      display: block;
                      margin-bottom: 4px;
                    "
                    >Information</strong
                  >
                  <span
                    style="color: #1976d2; font-size: 13px; line-height: 1.5">
                    Each page can have its own pagination configuration. Changes
                    are saved automatically. Click "Save" to save all
                    configurations.
                  </span>
                </div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </mat-tab>
  </mat-tab-group>

  <!-- Action Buttons -->
  <div class="action-buttons">
    <button
      mat-raised-button
      color="primary"
      (click)="
        selectedTabIndex === 0
          ? saveAccount()
          : selectedTabIndex === 1
            ? saveNotifications()
            : selectedTabIndex === 2
              ? saveBilling()
              : selectedTabIndex === 3
                ? saveConfig()
                : null
      ">
      Save
    </button>
    <button mat-raised-button color="warn" (click)="cancel()">Cancel</button>
  </div>
</div>
